import CardStockNew from "../../../components/screen/inventory/CardStock/CardStockNew";
import HOC from "../../../components/HOC";
import PageTemplateNew from "../../../components/common/particles.jsx/PageTemplateNew";
import BreadcrumbCardstock from "../../../components/screen/inventory/CardStock/BreadcrumbCardstock";

const CardStockNewPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplateNew
        header={"Kartu Stok " + (isWarehouse ? "Central Warehouse" : "")}
        mainComponent={<CardStockNew isWarehouse={isWarehouse} />}
        pageRole={isWarehouse ? 30 : 24}
        breadcrumb={
          <BreadcrumbCardstock
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
      />
    </div>
  );
};

export default HOC(CardStockNewPage);
